import type { ServerEvent } from '~/routes/bolt/event/types';

type BaseData = { isBot: boolean };

class UserEvent<T extends BaseData> {
  serverEvents: ServerEvent[] = [];

  constructor(protected data: T) {
    return;
  }

  protected get sendsBeforeTags(): boolean {
    return false;
  }

  sendServerEvents() {
    if (!this.serverEvents.length || this.data.isBot) return;

    const events = this.serverEvents;
    this.serverEvents = [];

    return fetch('/bolt/event', {
      body: JSON.stringify({ events }),
      headers: { 'Content-Type': 'application/json' },
      keepalive: this.sendsBeforeTags,
      method: 'POST'
    });
  }

  async sendToFacebook() {}

  async sendToTikTok() {}

  async sendToTwitter() {}

  sendToGtm() {}

  sendToAlgolia() {}

  sendToServer() {}

  sendToBraze() {}

  collectServerEvents() {}

  async send() {
    await this.collectServerEvents();

    // A click-out opens the retailer in a new tab, and iPhone Safari freezes this
    // page within ~150 ms, so its events can't wait for the marketing tags.
    if (this.sendsBeforeTags) this.sendServerEvents();

    await Promise.allSettled([
      this.sendToFacebook(),
      this.sendToTikTok(),
      this.sendToTwitter(),
      this.sendToGtm(),
      this.sendToAlgolia(),
      this.sendToServer(),
      this.sendToBraze()
    ]);

    await this.sendServerEvents();
  }
}

export default UserEvent;
